export const currencies = [
	// Arabian Area
	{ label: "Saudi Riyal (﷼)", value: "SAR" },
	{ label: "UAE Dirham (د.إ)", value: "AED" },
	{ label: "Egyptian Pound (£)", value: "EGP" },
	{ label: "Qatari Riyal (﷼)", value: "QAR" },
	{ label: "Kuwaiti Dinar (د.ك)", value: "KWD" },
	{ label: "Omani Rial (﷼)", value: "OMR" },
	{ label: "Bahraini Dinar (.د.ب)", value: "BHD" },
	{ label: "Jordanian Dinar (د.ا)", value: "JOD" },
	{ label: "Iraqi Dinar (ع.د)", value: "IQD" },
	{ label: "Yemeni Rial (﷼)", value: "YER" },

	// Major Global Currencies
	{ label: "United States Dollar ($)", value: "USD" },
	{ label: "Euro (€)", value: "EUR" },
	{ label: "British Pound Sterling (£)", value: "GBP" },
	{ label: "Chinese Yuan Renminbi (¥)", value: "CNY" },
	{ label: "Japanese Yen (¥)", value: "JPY" },
];
